import Dashboard from "@/pages/dashboard/dashboard-page.vue";

export default [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    component: Dashboard,
  },
];
